import React, { useState } from 'react';
import { Package } from 'lucide-react';
import ImportTemplateModal from '../components/ImportTemplateModal';
import toast from 'react-hot-toast';
import predefineTemplateService from '../services/predefineTemplateService';

const TestImportTemplate = () => {
  const [showImportModal, setShowImportModal] = useState(false);
  const [dataroomId] = useState(1); // Test dataroom ID

  // Handle the actual import of template
  const handleImportTemplate = async (template) => {
    try {
      // Call the API to import template to dataroom
      const response = await predefineTemplateService.importTemplate(
        template.id,
        dataroomId,
        {
          target_folder: null // Optional: specify target folder
        }
      );

      toast.success('Template imported successfully');
      return response;
    } catch (error) {
      console.error('Failed to import template:', error);
      toast.error('Failed to import template');
      throw error;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white rounded-lg shadow-sm p-6">
          <h1 className="text-2xl font-bold mb-6">Import Template Test Page</h1>

          <button
            onClick={() => setShowImportModal(true)}
            className="flex items-center gap-2 px-3 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            <Package className="w-5 h-5" />
            Import Template
          </button>

          <div className="mt-6 p-4 bg-gray-100 rounded-lg">
            <h2 className="font-semibold mb-2">Instructions:</h2>
            <ol className="list-decimal list-inside space-y-1 text-sm text-gray-700">
              <li>Click "Import Template" button to open the modal</li>
              <li>Step 1: Select a template from the list (should show folder count)</li>
              <li>Click "Next" button to proceed to Step 2</li>
              <li>Step 2: Preview the template structure</li>
              <li>Click "Import Template" to complete the import</li>
            </ol>
          </div>
        </div>
      </div>

      {/* Import Template Modal */}
      <ImportTemplateModal
        isOpen={showImportModal}
        onClose={() => setShowImportModal(false)}
        onImport={handleImportTemplate}
        dataroomId={dataroomId}
      />
    </div>
  );
};

export default TestImportTemplate;